import React from 'react';

interface SVGProps {
  title?: string;
  titleId?: string;
  className: string;
}

const IconSeekPassInvertSVG = ({
  title,
  titleId,
  ...props
}: SVGProps): JSX.Element => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" {...props}>
    <path
      fill="#fff"
      d="m19.49,5.13L10.49.13c-.3-.17-.67-.17-.97,0L.51,5.13c-.32.18-.51.51-.51.87v10c0,.36.2.7.51.87l9,5c.15.08.32.13.49.13s.33-.04.49-.13l9-5c.32-.18.51-.51.51-.87V6c0-.36-.2-.7-.51-.87Z"
    />
    <path
      fill="#503dc9"
      d="m9,14c-.26,0-.51-.1-.71-.29l-2.71-2.71,1.41-1.41,2,2,4-4,1.41,1.41-4.71,4.71c-.2.2-.45.29-.71.29Z"
    />
  </svg>
);

export default IconSeekPassInvertSVG;
